// extracted by mini-css-extract-plugin
export default {"header":"styles_header__polKy","titleWrapper":"styles_titleWrapper__8OHD0"};